<template>
    <span :id="id" />
</template>

<script>
export default {
    props: {
        slice: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            id: this.slice.id.replaceAll('$', '-')
        };
    }
};
</script>